import React, {Component} from 'react'
import PropTypes from 'prop-types'
import Modal from 'react-modal'
import {showModal, hideModal, QBM_SEND, INFO, INFO_TYPE_INFO, INFO_TYPE_ERROR, QBM_USER_BOOKS} from '../../../modules/modals'
import {handleSendQuestion} from "../../../modules/questions";
import {tutorialModeSelector, setTutorialMode} from '../../../modules/tutorial'
import { connect } from 'react-redux'
import { reduxForm, reset } from 'redux-form'
import Form from './Form.jsx'


class QbmSendModal extends Component {
    render() {
        let {zIndex} = this.props

        return (
            <Modal
                isOpen = {true}
                style = {{
                    overlay : {zIndex},
                }}
                onRequestClose={this.handleClose}
                overlayClassName = "custom-modal"
                className = "custom-modal-content create-dialog-modal-content"
            >
                <div className="create-dialog-modal-content__header">
                    {
                        this.getTitle()
                    }
                    <div
                        onClick={this.handleClose}
                        className="create-dialog-modal-content__close"
                    ></div>
                </div>
                <div className="create-dialog-modal-content__body">
                    {
                        this.getBody()
                    }
                </div>
            </Modal>
        )
    }


    handleOpenAddressBooksModal = () => {
        const {showModal, qbmId} = this.props;
        showModal({
            modalType : QBM_USER_BOOKS,
            modalProps : {
                qbmId,
            }
        });
        this.handleClose()
    }

    handleClose = () => {
        const {hideModal, setTutorialMode, tutorialModeIsOn} = this.props
        this.massFormReset()
        hideModal({ modalType : QBM_SEND})
        if (tutorialModeIsOn) {
            setTutorialMode(false)
        }
    }

    notifySuccess = () => () =>{
        const{showModal, hideModal} = this.props
        showModal({
            modalType : INFO,
            modalProps : {
                title : "Info",
                text : 'txtShareSuccess',
                infoType : INFO_TYPE_INFO,
            }
        });
    }

    massFormReset = () => {
        const {resetForm} = this.props
        let formsForReset = ['createSubject', 'updateSubject', 'createCategory', 'updateCategory', 'createSource', 'updateSource']
        formsForReset.forEach(f => resetForm(f)())
    }

    getTitle = () => {
        const {qbmCrudAction, qbmEntity} = this.props
        const {formatMessage} = this.context
        const Title = this.Title
        let text = "frmShareQuestionCaption"

        return <Title>{formatMessage(text)}</Title>
    }
    getBody = () => {
        const {qbmCrudAction, qbmEntity, qbmId, currentSubject = {}, userEmail, parentCategories, currentCategory = {}, currentSource = {}, resetForm} = this.props
        const {id : subjectId, name : subjectName} = currentSubject
        const {id : categoryId, name : categoryName, parent_id : category_parent_id} = currentCategory
        const {id : sourceId, name : sourceName} = currentSource
        const {formatMessage} = this.context
        return (
            <this.CreateSendForm
                type = "create"
                successMessage = {`${formatMessage("txtMessageShared")}.`}
                handleClose = {this.handleClose}
                resetForm = {resetForm("createSubject")}
                handleOpenAddressBooksModal={this.handleOpenAddressBooksModal}
                initialValues={{name: userEmail || ''}}
            />
        )
    }
    CreateSendForm = reduxForm({
        form: 'createSend',
        onSubmit : (values, dispatch) => {
            const {hideForm, name, setFocus} = values
            const{qbmId} = this.props
            return handleSendQuestion({name, qbmId})
                    .then(subject => {
                        dispatch(reset("createSend"))
                        if (hideForm){
                            setTimeout(()=>{
                                this.handleClose();
                            },2000)
                        }
                        if (setFocus) setFocus()
                        const {tutorialModeIsOn, handleStep_selectSubjectStep} = this.props
                        if (tutorialModeIsOn) {
                            this.handleClose()
                            handleStep_selectSubjectStep()
                        }
                    })
        },
    })(Form)

    Title = ({children}) => (
        <div className="create-dialog-modal-content__title">{children}</div>
    )
    static contextTypes = {formatMessage: PropTypes.any}
}

export default connect(
    state => ({
        tutorialModeIsOn : tutorialModeSelector(state),
    }),
    dispatch => ({
        hideModal : (...args) => dispatch(hideModal(...args)),
        showModal : (...args) => dispatch(showModal(...args)),
        resetForm : (form) => () => dispatch(reset(form)),
        setTutorialMode : (...args) => dispatch(setTutorialMode(...args)),
    })
)(QbmSendModal)


// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/QbmPage/QbmSendModal/index.js